import styled, { css } from 'styled-components';
import { SEM_BORDER_WIDTH_FORMS_DEFAULT, SYS_SPACE_FIXED_200, getMargins, SYS_BORDER_RADIUS_MD, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_50, getTypographyStyles, SEM_TYPOGRAPHY_FORMS_CAPTION, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-alpha-common';
import {} from './index.js';
export const StyledExtendedSelection = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  flex-direction: column;
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: box-shadow, background-color;
  background-color: ${(props) => props.theme.cmp.color.forms.extendedSelection.surface.fill.default};
  overflow: hidden;
  border-radius: ${SYS_BORDER_RADIUS_MD};

  ${(props) => css `
    box-shadow: 0 0 0 ${SEM_BORDER_WIDTH_FORMS_DEFAULT}
      ${props.theme.cmp.color.forms.extendedSelection.surface.stroke.default};
  `}

  &:has(input:checked) {
    background-color: ${(props) => props.theme.cmp.color.forms.extendedSelection.surface.fill.active};

    ${(props) => css `
      box-shadow: 0 0 0 ${SEM_BORDER_WIDTH_FORMS_DEFAULT}
        ${props.theme.cmp.color.forms.extendedSelection.surface.stroke.active};
    `}
  }
`;
export const StyledImageLG = styled.img `
  aspect-ratio: ${(props) => (props.ratio === '1/1' ? '1/1' : '16/9')};
  width: 100%;
`;
export const StyledInner = styled.div `
  padding: ${SYS_SPACE_FIXED_200};
  gap: ${SYS_SPACE_FIXED_200};
  display: flex;
  flex-direction: column;
`;
export const StyledToolbar = styled.span `
  display: flex;
  padding-top: ${SYS_SPACE_FIXED_200};
  box-shadow: 0 -${SYS_SIZE_FIXED_50} 0 0 ${(props) => props.theme.sem.color.ui.foreground.divider.default};
`;
export const StyledImageSM = styled.img `
  width: ${SYS_SIZE_FIXED_1400};
  aspect-ratio: 1/1;
`;
export const StyledInnerHeader = styled.span `
  display: flex;
  justify-content: space-between;
  gap: ${SYS_SPACE_FIXED_200};
  align-items: flex-start;
`;
export const StyledPrice = styled.div `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_CAPTION)}
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default}
`;
export const StyledInputContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_150};
`;
export const StyledComponentButtonContainer = styled.div `
  display: flex;
  gap: ${SYS_SPACE_FIXED_100};
  align-items: flex-start;
`;
//# sourceMappingURL=index.styles.js.map